import { IconTriangleWarningOutline18 as AlertTriangle } from "nucleo-ui-outline-18"

import { Tooltip } from "@productlane/ui"

export function unverifiedContactTooltip(agentEnabled: boolean): string {
	const base =
		"This contact typed their own email, so this data may belong to someone else."
	return agentEnabled
		? `${base} The Productlane Agent skips connectors on an unverified contact.`
		: base
}

// Same icon and orange as the unverified-sender mark on a message, so the panel
// and the message read as one concept.
export function UnverifiedContactWarning({
	agentEnabled,
	className,
}: {
	agentEnabled: boolean
	className?: string
}) {
	return (
		<Tooltip
			label={
				<span className="block max-w-56">
					{unverifiedContactTooltip(agentEnabled)}
				</span>
			}
			shouldWrapChildren
		>
			<AlertTriangle
				color="orange"
				className={className ?? "ml-1 h-3.5 w-3.5 flex-none"}
			/>
		</Tooltip>
	)
}
